<template>
    <div class="flex">
		<IndustrySelect class="flex_1"
						v-model="selectedValues"
						:label-text="labelText"
						ref="select"
		/>
    </div>
</template>
<script>
import IndustrySelect from "@/components/templates/select/IndustrySelect.vue";

export default {
	components: { IndustrySelect },
    props: {
        labelText: { type: String },
        columnName: { type: String },
        initialValues: { type: Array, default: [] }
    },
    data() {
        return {
            selectedValues: this.initialValues,
        };
    },
    methods: {
        clearFilter() {
            this.selectedValues = [];
			this.$refs.select.resetSearch();
        },
        getFilter() {
            if (this.selectedValues.length === 0) {
                return null;
            }

            return [{
                columnName: this.columnName,
                fieldType: "S",
                matchType: "IN",
                value: this.selectedValues.join(",")
            }];
        },
        setFilter(filter) {
            this.selectedValues = filter.value.split(",");
        }
    }
};
</script>
